export default __webpack_public_path__ + "static/media/Technical1.8335eedd.jpg";